import axios from "axios";
import routes from "../../../app/routes";

const prepareFormDataForSend = (values) => {
  let formData = {
    number: values.number,
    cycle_start: values.cycleStart,
    cycle_end: values.cycleEnd,
    grace_period: values.gracePeriod,
    current: values.current ? 1 : 0,
  };
  return formData;
};

const create = (values, teamId, afterSave) => {
  axios
    .post(routes.api.cycles.create, {
      cycle: { ...prepareFormDataForSend(values) },
      enterprise_team_id: teamId,
    })
    .then((resp) => {
      afterSave();
    })
    .catch(function (error, data) {
      swal(error.response.data.error);
    });
};

const update = (id, values, teamId, afterSave) => {
  axios
    .patch(routes.api.cycles.update(id), {
      cycle: { ...prepareFormDataForSend(values) },
      enterprise_team_id: teamId,
    })
    .then((resp) => {
      afterSave();
    })
    .catch(function (error, data) {
      swal(error.response.data.error);
    });
};

const saveForm = (values, initialFormValues, teamId, afterSave) => {
  if (initialFormValues.id == null) {
    create(values, teamId, afterSave);
  } else {
    update(initialFormValues.id, values, teamId, afterSave);
  }
};

export default saveForm;
